import _slicedToArray from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import { AppAlertsContext } from '@infl-ts/ui-app-alerts';
import { useToggle } from '@infl-ts/util-hooks';
import { api } from '@infl-ts/util-hub-axios-instance';
import { LoadingButton } from '@mui/lab';
import { pipe } from 'fp-ts/function';
import * as TE from 'fp-ts/TaskEither';
import { useContext } from 'react';
import { Tooltip } from '../tooltip';
import { jsx as _jsx } from "react/jsx-runtime";

var RewriteDisableButton = function RewriteDisableButton() {
  var _useContext = useContext(AppAlertsContext),
      showAlert = _useContext.showAlert;

  var _useToggle = useToggle(),
      _useToggle2 = _slicedToArray(_useToggle, 2),
      isLoading = _useToggle2[0],
      _useToggle2$ = _useToggle2[1],
      load = _useToggle2$.on,
      stopLoad = _useToggle2$.off;

  return /*#__PURE__*/_jsx(Tooltip, {
    disableFocusListener: true,
    arrow: true,
    title: "This will only affect your preview",
    "data-element": "Tooltip",
    "data-component": "RewriteDisableButton",
    "data-source-file": "rewrite-disable-button.tsx",
    children: /*#__PURE__*/_jsx(LoadingButton, {
      variant: "outlined",
      sx: function sx(t) {
        return {
          minWidth: 'fit-content',
          background: t.palette.common.white,
          '&:hover': {
            background: t.palette.common.white
          }
        };
      },
      loading: isLoading,
      onClick: function onClick() {
        load();
        void pipe(api.request({
          method: 'post',
          url: '/api/toggle_rewrite'
        }), TE.matchW(function () {
          stopLoad();
          showAlert({
            severity: 'error',
            message: 'Could not load Classic UI at this time, try again.',
            duration: 'medium'
          });
        }, function () {
          return window.location.href = '/';
        }))();
      },
      "data-element": "LoadingButton",
      "data-component": "RewriteDisableButton",
      "data-source-file": "rewrite-disable-button.tsx",
      children: "Return to Classic UI"
    })
  });
};

export default RewriteDisableButton;